export default "__VITE_ASSET__DNaA4Ch1__"